<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :buttonsVisibility="buttonsVisibility"
                :rowButtonAction="rowButtonAction"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <DictionaryForm :formProps="formProps">
                </DictionaryForm>
            </template>
            <template #search="searchProps">
                <DictionarySearch :searchProps="searchProps">
                </DictionarySearch>
            </template>

        </v-view>
    </div>
</template>

<script setup>
import DictionaryForm from './DictionaryForm.vue'
import DictionarySearch from './DictionarySearch.vue'
import { ref } from "vue";
import { rowButtonAction } from '@pages/Helper/crud_utils.js'

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

const selectedRows = ref([])

//----------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
